/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { iconTypes } from './NotificationModal';

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 24px;
  gap: 16px;
  width: 500px;
`;

export const Footer = styled.footer`
  display: flex;
  gap: 16px;
  background: ${() => Palette.PrimaryGray._000};
  padding: 16px 24px;
  width: 100%;

  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const NotificationIcon = styled.div`
  color: #fff;
  width: 48px;
  height: 48px;
  font-size: 24px;
  background: ${({ type }) => {
    if (type === iconTypes.error) return `${Palette.Red._500}`;
    if (type === iconTypes.info) return `${Palette.PrimaryGray._400}`;
    if (type === iconTypes.question) return `${Palette.Primary._500}`;
    if (type === iconTypes.warning) return `${Palette.Amber._500}`;
    return `${Palette.PrimaryGray._400}`;
  }};
  text-transform: none;
  font-weight: 600;
  line-height: 48px;
  display: flex;
  font-style: normal;
  justify-content: center;
  border-radius: 50%;
`;

export const ModalDeleteTitle = styled.h3`
  color: ${Palette.PrimaryGray._900};
  text-align: left;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const ModalDeleteText = styled.p`
  text-transform: none;
  text-align: left;
  padding: 0;
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 85%;
`;
